import * as React from 'react';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { ConfirmRequestCancelButtonCSSStyleImpl } from '../confirmrequest/confirmrequestcancelbutoncss';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import { DeleteConfirmComponentHandler, DeleteConfirmComponentProps } from './deleteconfirmationcomponent';
import { DeleteConfirmCSSStyle } from './deleteconfirmationcss';
import './delete-style.css';
export class DeleteConfirmViewImpl extends UIComponentViewImpl<UIDataModel>
{
 
    // popupComponent:PopUpWrapperComponent;
    bindHandlers()
    {   
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        // this.showPopup = this.showPopup.bind(this);
        // this.hidePopup = this.hidePopup.bind(this);
    }

    draw(props: DeleteConfirmComponentProps, state: UIComponentState, cssStyle: DeleteConfirmCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
             
              <div id="delete-wrapper">
            {
                this.getWebView(props, state, cssStyle)
            }
            </div>
            <div id="delete-col-wrapper">
                        {
                            this.getMobileView(props, state, cssStyle)
                        }
            </div>
              
                {/* <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/> */}

            </div>
        );
    }

    getWebView(props: DeleteConfirmComponentProps, state: UIComponentState, cssStyle: DeleteConfirmCSSStyle)
    {
        return(
            <>
               <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label id="delete-header-title" style={cssStyle.getTitleCSSStyle()}>{props.headerTitle}</label>
                    <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
                </div> 
                <div id="delete-confirm-msg" >
                    <label style={{width:'100%',height:'30px',fontWeight:300,lineHeight:'30px',fontSize:'24px',color:'#000000D9',marginTop:'20px'}}>
                    {props.context.getResources().getString(Strings.delete_mytune_confirmation)}
                    </label>
                    {/* <label style={{width:'100%',height:'30px',textAlign:'left',lineHeight:'30px',color:'#FFFFFF',fontSize:'24px',fontWeight:900}}>
                            {props.id}
                    </label> */}
                </div>
                <div id="delete-confirm-msg" >
                    <label style={{width:'100%',height:'30px',fontWeight:300,lineHeight:'30px',fontSize:'18px',color:'#000000D9',marginTop:'30px'}}>
                        {props.msg}
                    </label>
                    {/* <label style={{width:'100%',height:'30px',textAlign:'left',lineHeight:'30px',color:'#FFFFFF',fontSize:'24px',fontWeight:900}}>
                            {props.id}
                    </label> */}
                </div>
                {/* <label style={{width:'86%',marginLeft:'39px',marginRight:'21px', letterSpacing:'0', height:'18px',lineHeight:'18px',fontSize:'12px',color:'#000000',textAlign:'left'}}>
                        {"Thank you for your request, You will be charged 2k for Activation."}
                    </label> */}
                {/* <div style={{width:'100%',height:'40px',margin:'25px 21px 30px 39px',display:'flex'}}>
                        <div style={{width:'180px',height:'40px'}}>
                            <ButtonComponent onClick={this.onCancelClick} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                        </div>
                        <div id="delete-button" style={{width:'180px',height:'40px'}}>
                            <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
                        </div>
                </div> */}
                <div style={{width:'100%',height:'40px',marginTop:'40px', paddingLeft: "30px", paddingRight: "30px",display:'flex', justifyContent:"center"}}>
                        <div style={{width:'225px',height:'40px'}}>
                            <ButtonComponent onClick={this.onCancelClick} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                        </div>
                    <div style={cssStyle.getConfirmButtonCSSStyle()}>
                        <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.delete)}/>
                    </div>
                 </div>
            </>
        );
    }

    getMobileView(props: DeleteConfirmComponentProps, state: UIComponentState, cssStyle: DeleteConfirmCSSStyle)
    {
        return(
            <>  
             <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label id="delete-header-title" style={cssStyle.getMobileTitleCSSStyle()}>{props.headerTitle}</label>
                    <div style={cssStyle.getMobileCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
                </div> 
                <div id="delete-confirm-msg" >
                    <label style={{width:'100%',height:'30px',fontWeight:300,lineHeight:'25px',fontSize:'20px',color:'#000000D9',marginTop:'25px'}}>
                        {"Do you really want to Delete Blow My Mind"}
                    </label>
                    {/* <label style={{width:'100%',height:'30px',textAlign:'left',lineHeight:'30px',color:'#FFFFFF',fontSize:'24px',fontWeight:900}}>
                            {props.id}
                    </label> */}
                </div>
                <div id="delete-confirm-msg" >
                    <label style={{width:'100%',height:'30px',fontWeight:300,lineHeight:'20px',fontSize:'14px',color:'#000000D9',marginTop:'35px'}}>
                        {props.msg}
                    </label>
                    {/* <label style={{width:'100%',height:'30px',textAlign:'left',lineHeight:'30px',color:'#FFFFFF',fontSize:'24px',fontWeight:900}}>
                            {props.id}
                    </label> */}
                </div>
                {/* <label style={{width:'86%',marginLeft:'39px',marginRight:'21px', letterSpacing:'0', height:'18px',lineHeight:'18px',fontSize:'12px',color:'#000000',textAlign:'left'}}>
                        {"Thank you for your request, You will be charged 2k for Activation."}
                    </label> */}
                {/* <div style={{width:'100%',height:'40px',margin:'25px 0px 30px 0px',justifyContent: "center",display:'flex'}}>
                        <div style={{width:'110px',height:'40px'}}>
                            <ButtonComponent onClick={this.onCancelClick} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                        </div>
                        <div id="delete-button" style={{width:'110px',height:'40px'}}>
                            <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
                        </div>
                </div> */}
                 <div style={{width:'100%',height:'40px',marginTop:'40px', paddingLeft: "30px", paddingRight: "30px",display:'flex', justifyContent:"center"}}>
                        <div style={{width:'225px',height:'40px'}}>
                            <ButtonComponent onClick={this.onCancelClick} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                        </div>
                    <div style={cssStyle.getConfirmButtonCSSStyle()}>
                        <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.delete)}/>
                    </div>
                 </div>
            </>
        );
    }
   
    // showPopup(msg: string, type: AlertType,title:string)
    // {
    //     this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={this.hidePopup} context={this.getUIProps().context}/>);
    // }
    // hidePopup()
    // { 
    //     this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    // }
    private onCloseClick()
    {
        (this.getUIComponentHandler() as DeleteConfirmComponentHandler).closePopup();
    }
    private onConfirmClick():void
    {
       (this.getUIComponentHandler() as DeleteConfirmComponentHandler).onConfirmClick();
    }

    private onCancelClick():void
    {
        (this.getUIComponentHandler() as DeleteConfirmComponentHandler).onCancelClick();

    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/deleteconfirmation/deleteconfirmationview.tsx